import { useState } from "react";
import { useAuth } from "./AuthProvider";
import { Moon } from 'lucide-react';


const Login = () => {
  const [input, setInput] = useState({
    username: "",
    password: "",
  });


  const auth = useAuth();
  const handleSubmitEvent = (e) => {
    e.preventDefault();
    if (input.username !== "" && input.password !== "") {
      auth.loginAction(input);
      return;
    }
    alert("pleae provide a valid input");
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setInput((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div className="flex justify-center items-center h-screen">
      <div className="bg-white rounded-2xl shadow-2xl w-full sm:w-1/2  p-6">
        <div className="flex shrink-0 items-center mb-8">
            <h1 className="flex items-center justify-center gap-3 text-2xl mb-2 font-bold text-purple-800  ">
              <Moon className="w-10 h-10" />
              <span className="">Log in</span>
            </h1>

        </div>

        <form onSubmit={handleSubmitEvent}>
                      <div className="mb-4">
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          Email *
                        </label>
                        <input
                          type="text"
                          id="user-email"
                          name="username"
                          placeholder="Email"
                          aria-describedby="user-email"
                          aria-invalid="false"
                          onChange={handleInput}
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                        />
                        <div id="user-email" className="sr-only">
                          Please enter a valid username. It must contain at least 6 characters.
                        </div>
                      </div>

                      <div className="mb-4">
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          Password *
                        </label>
                        <input
                          type="password"
                          id="password"
                          name="password"
                          placeholder="Password"
                          aria-describedby="user-password"
                          aria-invalid="false"
                          onChange={handleInput}
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                        />
                        <div id="user-password" className="sr-only">
                          your password should be more than 6 character
                        </div>

                      </div>


          <button className="px-6 bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold py-3 rounded-lg transition-all">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default Login;